import { Middleware, PayloadAction } from '@reduxjs/toolkit'
import RestUtils from '../../utils/restUtils'
import {
  EndNetwork,
  ErrorMessage,
  GetAccessToken,
  StartNetwork,
} from '../Application/appActions'
import { APIArgs, ApplicationActionTypes } from '../Application/appState'

function readAsString(callback: (message: string) => void, message: Blob) {
  const fr = new FileReader()

  fr.onload = (e) => {
    callback(JSON.parse(e.target?.result?.toString() || '{}').message)
  }

  fr.readAsText(message)
}

const API: Middleware =
  ({ dispatch }) =>
  (next) =>
  async (action: unknown) => {
    const _action = action as PayloadAction<APIArgs>

    if (
      !action ||
      _action.type !== ApplicationActionTypes.API ||
      !_action.payload
    ) {
      return next(action)
    }

    const { label } = _action.payload || {}
    const {
      method,
      url,
      data,
      additionalHeaders,
      isFileUpload,
      isFileDownload,
      onSuccess,
      onError,
      onProgress,
      responseType,
      uploadParameterName,
    } = _action.payload.configuration

    dispatch(StartNetwork(label))

    let accessToken = ''
    try {
      accessToken = await GetAccessToken()
    } catch (err) {
      console.error(err)
      window.location.replace('/error')
      return next(action)
    }

    RestUtils.request(
      method,
      url,
      data,
      isFileUpload,
      isFileDownload,
      onProgress,
      additionalHeaders,
      accessToken,
      responseType,
      uploadParameterName
    )
      .then((response) => {
        if (!response.content) return null
        try {
          return JSON.parse(response.content)
        } catch (err) {
          console.warn(
            'error parsing api response, return raw content',
            err,
            response.content
          )
          return response.content
        }
      })
      .then((resp) => {
        onSuccess && onSuccess(resp)
      })
      .catch((err) => {
        console.error(err)
        if (!err && !onError) {
          ErrorMessage('Error', 'Undefined error')
        } else if (!onError) {
          if (err.message instanceof Blob) {
            readAsString(
              (message) => ErrorMessage('Error', message),
              err.message
            )
          } else if (err.response?.data) {
            ErrorMessage('Error', err.response.data.message)
          } else {
            console.warn(err)
            ErrorMessage('Error', err)
          }
        }

        if (onError) {
          const errorMessage =
            err.response?.data?.message ||
            err.error ||
            'request has no response'
          onError(errorMessage, err.statusCode || 500)
        }
      })
      .finally(() => {
        dispatch(EndNetwork(label))
      })

    return next(action)
  }

export default API
